import{RECEIVE_INVENTORIES}from"../constants";/**
 * Creates the dispatched RECEIVE_PRODUCT_INVENTORIES action object.
 * @param {Array} productCodes The code of the product.
 * @param {Array} locationCodes List of location codes.
 * @param {Array} inventories List of product invetories.
 * @return {Object} The RECEIVE_PRODUCT_LOCATIONS action.
 */var receiveInventories=function receiveInventories(productInventories){return{type:RECEIVE_INVENTORIES,productInventories:productInventories};};export default receiveInventories;